import envConfig from '@/env.config';

const loadScript = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Script load error for ${src}`));
    document.body.appendChild(script);
  });
};

export const loadSearchBarScript = async () => {
  try {
    const scriptSrc = `https://api.search.gov.sg/v1/searchconfig.js?clientId=${envConfig.external.searchSg}`;
    await loadScript(scriptSrc);
  } catch (error) {
    console.error('Failed to load Search Box script:', error);
  }
};

export const loadSearchResultsPageScript = async () => {
  try {
    const scriptSrc = `https://api.search.gov.sg/v1/searchconfig.js?clientId=${envConfig.external.searchSg}&page=result`;
    await loadScript(scriptSrc);
  } catch (error) {
    console.error('Failed to load Search Results Page script:', error);
  }
};
